import React, { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import { Colors } from "../../Constants/colors";
import { FontFamily } from "../../Constants/Enums/FontFamily.enums";
import { display } from "@mui/system";
import {
  ALIGN_ITEMS,
  DISPLAY,
  FLEX_DIRECTION,
  JUSTIFY_CONTENT,
} from "../../Constants/Enums/styles.enum";
import { FontSize } from "../../Constants/Enums/Size.enums";

interface Props {
  label?: string;
  children: ReactNode;
  wrapperClassName?: string;
  wrapperStyle?: {};
  infoMessage?: string | null;
  headerComponent?: ReactNode | null;
}
const InputWrapper = ({
  label,
  children,
  wrapperClassName,
  wrapperStyle = {},
  infoMessage = null,
  headerComponent = null,
}: Props) => {
  return (
    <div
      className={`my-4 w-full ${wrapperClassName}`}
      style={{ ...wrapperStyle }}
    >
      <Box
        style={{
          display: DISPLAY.FLEX,
          flexDirection: FLEX_DIRECTION.ROW,
          alignItems: ALIGN_ITEMS.CENTER,
          justifyContent: JUSTIFY_CONTENT.SPACE_BETWEEN,
        }}
      >
        <Box color={Colors.DarkGrey}>{label}</Box>
        {headerComponent ? <Box>{headerComponent}</Box> : <></>}
      </Box>
      <Box position={"relative"} style={{ display: "flex" }}>
        {children}
      </Box>
      {infoMessage ? (
        <Typography
          style={{
            fontSize: "12px",
            color: Colors.Tomato,
            marginTop: "6px",
            fontFamily: FontFamily.POPPINS_REGULAR,
          }}
        >
          {infoMessage}
        </Typography>
      ) : (
        <></>
      )}
    </div>
  );
};

export const inputButtonStyle = {
  border: `2px solid ${Colors.LightGrey}`,
  borderRadius: "8px",
  padding: "10px",
  width: "100%",
  height: "45px",
  minHeight: "45px",
  marginTop: "5px",
  color: `${Colors.DarkGrey}`,
  fontFamily: FontFamily.POPPINS_REGULAR,
  fontSize: FontSize.F14,
};
export default InputWrapper;
